import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { TipoPadronagem } from 'src/app/models/api/comercial/tipo-padronagem';

@Injectable({
  providedIn: 'root'
})
export class ApiTipoPadronagemService {
  private baseUrl = 'TipoPadronagem';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<TipoPadronagem[]>('');
  }
}
